import React, { useState } from 'react';
import { Box, Button, Container, Paper, Stack, TextField, Typography } from '@mui/material';
import data from '../data/chords.json';
import { ChordVariations, chordLibrary, normalizeChord } from '../Components/ChordViewer';

export default function ChordsPage() {
  const [search,setSearch]=useState('');
  const [selected,setSelected]=useState('C');
  const [root,setRoot]=useState('All');
  const names=Object.keys(chordLibrary).filter(n=>(root==='All'||chordLibrary[n].root===root)&&n.toLowerCase().includes(normalizeChord(search.trim()).toLowerCase()));
  const count=Object.values(chordLibrary).reduce((sum,c)=>sum+c.variations.length,0);
  return <Container maxWidth="lg" sx={{py:{xs:3,md:6}}}>
    <Typography variant="overline" color="primary">YOUR FRETBOARD COMPANION</Typography>
    <Typography variant="h3" fontWeight={800} mt={1}>Find your next chord.</Typography>
    <Typography color="text.secondary" mt={2} mb={4}>{Object.keys(chordLibrary).length} chords · {count.toLocaleString()} voicings · Standard tuning · Capo 0–7</Typography>
    <Box display="grid" gridTemplateColumns={{xs:'1fr',md:'1fr 370px'}} gap={3} alignItems="start">
      <Box>
        <TextField fullWidth label="Search chords" placeholder="Try Am7, F# or Bb" value={search} onChange={e=>setSearch(e.target.value)}/>
        <Stack direction="row" flexWrap="wrap" gap={1} my={2}>{['All',...data.roots].map(r=><Button key={r} size="small" variant={root===r?'contained':'outlined'} onClick={()=>setRoot(r)}>{r}</Button>)}</Stack>
        <Typography variant="body2" color="text.secondary" mb={2}>Choose a chord to explore its shapes.</Typography>
        <Box display="grid" gridTemplateColumns="repeat(auto-fill, minmax(90px, 1fr))" gap={1}>
          {names.map(n=><Button key={n} variant={selected===n?'contained':'outlined'} onClick={()=>setSelected(n)} sx={{py:2,textTransform:'none',fontSize:16}}>{n}</Button>)}
        </Box>
        {!names.length && <Typography my={3}>No matching chords. Try another name or root.</Typography>}
      </Box>
      <Paper variant="outlined" sx={{p:3,borderRadius:3,position:{md:'sticky'},top:84,gridRow:{xs:1,md:'auto'},gridColumn:{md:2}}}>
        <ChordVariations key={selected} name={selected}/>
      </Paper>
    </Box>
  </Container>;
}
